import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon, BookOpenIcon, TrophyIcon, ArrowRightIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const plans = [{
  id: 'base',
  title: 'PACK HYROX IMPARABLE',
  subtitle: '3 módulos + 3 bonos estratégicos',
  oldPrice: '$49.990',
  price: '$19.990',
  icon: BookOpenIcon,
  checkout: 'https://checkout.ideahubdigital.online/cart/48835372548315:1'
}, {
  id: 'total',
  title: 'PACK HYROX IMPARABLE TOTAL',
  subtitle: '3 módulos + 3 bonos + Tomos Fuerza y Primera Carrera',
  oldPrice: '$69.990',
  price: '$29.990',
  icon: TrophyIcon,
  featured: true,
  save: 'AHORRÁS $10.000',
  checkout: 'https://checkout.ideahubdigital.online/cart/48835375857883:1'
}];
export function Pricing() {
  const [selected, setSelected] = useState('total');
  const activePlan = plans.find(p => p.id === selected) ?? plans[1];
  const ctaLabel = selected === 'total' ? '💥 SÍ, QUIERO EL PACK TOTAL' : '💥 SÍ, QUIERO EL PACK BASE';
  return <section id="pricing" className="py-12 md:py-16 px-4 bg-brand-black relative" data-id="element-185">
      <div className="max-w-3xl mx-auto" data-id="element-186">
        {/* Compact scarcity bar */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col sm:flex-row items-center justify-between gap-3 bg-brand-dark border border-brand-pink/30 rounded-xl px-4 py-3 mb-5 shadow-[0_0_30px_rgba(255,59,92,0.08)]" data-id="element-187">
          <div className="flex items-center gap-2 text-brand-pink font-bold uppercase tracking-wider text-xs" data-id="element-188">
            <span className="w-2 h-2 rounded-full bg-brand-pink animate-pulse" data-id="element-189" />
            Oferta en vivo
            <span className="text-gray-500 font-medium normal-case tracking-normal hidden sm:inline" data-id="element-190">
              · +$10.000 después
            </span>
          </div>
          <div className="flex items-center gap-2 text-white" data-id="element-191">
            <span className="text-[11px] text-gray-400 uppercase tracking-widest font-bold" data-id="element-192">
              Termina en
            </span>
            <CountdownTimer data-id="element-193" />
          </div>
        </motion.div>

        <div className="text-center mb-5" data-id="element-194">
          <h2 className="text-2xl md:text-4xl text-white font-display mb-1" data-id="element-195">
            Elegí tu Pack HYROX Imparable
          </h2>
          <p className="text-brand-copper text-sm" data-id="element-196">
            Ambas opciones incluyen los 3 bonos estratégicos completos
          </p>
        </div>

        {/* Selectable stacked cards */}
        <div className="space-y-3" data-id="element-197">
          {plans.map((plan, i) => {
          const isSelected = selected === plan.id;
          const Icon = plan.icon;
          return <motion.button key={plan.id} type="button" onClick={() => setSelected(plan.id)} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} aria-pressed={isSelected} className={`w-full text-left rounded-2xl p-4 md:p-5 flex items-center gap-3 md:gap-4 transition-all relative ${plan.featured && isSelected ? 'bg-brand-black border-2 border-brand-pink shadow-[0_0_25px_rgba(255,59,92,0.25)]' : isSelected ? 'bg-brand-dark border-2 border-brand-pink/70' : 'bg-brand-dark border-2 border-gray-800 hover:border-gray-700'}`} data-id="element-198">
                {/* Radio */}
                <span className={`flex-shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-brand-pink' : 'border-gray-600'}`} data-id="element-199">
                  {isSelected && <span className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-brand-pink" data-id="element-200" />}
                </span>

                {/* Main content */}
                <div className="flex-grow min-w-0" data-id="element-201">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-202">
                    <Icon className={`w-4 h-4 md:w-5 md:h-5 flex-shrink-0 ${plan.featured ? 'text-brand-pink' : 'text-gray-400'}`} data-id="element-203" />
                    <h3 className="font-display text-sm md:text-lg tracking-wide text-white leading-tight" data-id="element-204">
                      {plan.title}
                    </h3>
                  </div>

                  {/* Badges */}
                  {plan.featured && <div className="flex flex-wrap items-center gap-1.5 mb-1" data-id="element-205">
                      <span className="inline-flex items-center gap-1 bg-brand-pink text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase" data-id="element-206">
                        ⭐ MÁS ELEGIDO
                      </span>
                      <span className="inline-flex items-center bg-green-500/15 text-green-400 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase border border-green-500/30" data-id="element-207">
                        {plan.save}
                      </span>
                    </div>}

                  <p className="text-gray-400 text-[11px] md:text-sm leading-snug" data-id="element-208">
                    {plan.subtitle}
                  </p>
                </div>

                {/* Price */}
                <div className="flex-shrink-0 text-right" data-id="element-209">
                  <div className="text-gray-500 line-through text-[11px] md:text-sm" data-id="element-210">
                    {plan.oldPrice}
                  </div>
                  <div className={`font-display text-xl md:text-3xl leading-none ${plan.featured ? 'text-brand-pink' : 'text-white'}`} data-id="element-211">
                    {plan.price}
                  </div>
                </div>
              </motion.button>;
        })}
        </div>

        {/* Shared buy button — links to the selected plan's checkout */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-4" data-id="element-212">
          <a href={activePlan.checkout} className="w-full bg-brand-pink text-white font-display text-base md:text-2xl py-4 md:py-5 rounded-2xl hover:bg-brand-pink/90 transition-all transform hover:scale-[1.02] shadow-[0_0_25px_rgba(255,59,92,0.35)] flex items-center justify-center gap-3" data-id="element-213">
            {ctaLabel}
            <ArrowRightIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-214" />
          </a>
          <p className="text-center text-xs md:text-sm text-gray-400 italic mt-3" data-id="element-215">
            La opción más elegida por mujeres que van en serio hacia su primera
            carrera HYROX
          </p>
        </motion.div>

        {/* Trust row */}
        <div className="flex flex-wrap justify-center items-center gap-3 md:gap-6 mt-5 text-xs md:text-sm text-gray-400" data-id="element-216">
          <div className="flex items-center gap-1.5" data-id="element-217">
            <LockIcon className="w-4 h-4" data-id="element-218" />
            <span data-id="element-219">Pago seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-220">
            <ZapIcon className="w-4 h-4" data-id="element-221" />
            <span data-id="element-222">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-223">
            <ShieldCheckIcon className="w-4 h-4" data-id="element-224" />
            <span data-id="element-225">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-226">
            <CreditCardIcon className="w-4 h-4" data-id="element-227" />
            <span data-id="element-228">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}